import { style } from "typestyle"

export const headerContainer = style({ 
    display: "flex",
    flexDirection: "row",
    justifyContent:"flex-end",
    alignItems:"center",
    columnGap:"0.75rem",
    minHeight:"5rem"
})